import {api} from './requestGraphql'
import request from "./request";
import {getCookie} from "@/helpers";

const getAdvInvoices = async (data) => {
    try {
        let preparedFilters = ''
        let reportType = data.payload.reportType ? `reportType: "${data.payload.reportType}"` : '';

        for (const filter in data.payload.filters) {
            preparedFilters += (!!data.payload.filters[filter]) ?
                `${filter}: "${data.payload.filters[filter]}"` : ''
        }

        const res = await api.post(
        '', {
            query: `
              {
                getAdvInvoices(
                    pagination: {
                        page: ${data.payload.page},
                        limit: ${data.payload.limit}
                    },
                    sorting: {
                        orderBy: "${data.payload.orderBy}",
                        orderDirectionAsc: ${data.payload.orderDirectionAsc}
                    }, 
                    filters: {${preparedFilters}}
                    ${reportType}
                ){
                    invoicesPeriods {
                        cost
                        sales
                        period
                        sub_period
                        commissions
                        modifications
                        revenue
                        geo
                        program_id
                        program_name
                        margin
                        start
                        end
                        revenue_eur
                        modifications_eur
                        commissions_eur
                        rate
                        corps{
                          name
                          corp_id
                          corp_name
                          corp_term
                          corp_code
                          corp_currency
                          corp_branding_theme
                          cost
                          sales
                          margin
                          geo
                          program_id
                          program_name
                          modifications
                          revenue
                          revenue_eur
                          modifications_eur
                          commissions_eur
                          commissions
                        }
                    }
                }
              }
            `,
          }
        )

        return res.data.data.getAdvInvoices.invoicesPeriods;
    } catch (error) {
        console.error(error);
    }
}

const downloadFiles = async (data) => {

    const invoices = JSON.stringify(data.preparedValues).replace(/"/g, '').replace(/'/g, '"');
    const { reportType } = data;

    try {
        const res = await api.post(
            '', {
            query: `
                {
                    getFile(
                        data: ${invoices},
                        reportType: "${reportType}"
                    ) {
                        content
                        type
                    }
                }
            `
            }
        );

        return res.data.data.getFile;
    } catch (error) {
        console.error(error);
    }
}

const invoiceFilters = async (data) => {
    const preparedFilter = []
    if(data.filter) {
        for (let i = 0; i < data.filter.length; i++) {
            preparedFilter.push(
                (!!data.filter[i]) ? `{ field: "${data.filter[i].field}", value: [${data.filter[i].value.map(v => `"${v}"`)}] }` : ''
            )
        }
    }

    data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''

    const result = await request.post(`/graphql`, {
            query: `
          {
            invoicesFilterData(name: "${data.name}", searchFilter: "${data.searchFilter || ''}", ${data.filter}) {
              key,
              value
            }
          }
        `
        },
        {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        }
    )

    if(result.status === 200) {
        const prettyData = [];
        if(result.data.data.advertiserFilterData) {
            for(let i = 0; i < result.data.data.advertiserFilterData.length; i++) {
                prettyData.push(result.data.data.advertiserFilterData[i]);
            }
            return prettyData;
        }
    }
}

const getFilter = async () => {

    const result = await request.post(`/graphql`, {
            query: `
              {
                getAdvInvoices(
                    filtersOptions: {filtersOnly: true}
                ){
                    filters {
                        cost { key value}
                        sales { key value }
                        modifications { key value }
                        revenue { key value}
                        revenue_eur { key value}
                        commissions { key value}
                        commissions_eur { key value}
                    }
                }
              }
            `
        },
        {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        }
    )

    return result.data.data.getAdvInvoices.filters;
}

export default {
    getAdvInvoices,
    downloadFiles,
    getFilter
}